
var content = require("!!../../_css-loader@1.0.1@css-loader/index.js!../../_resolve-url-loader@3.1.0@resolve-url-loader/index.js!../../_less-loader@4.1.0@less-loader/dist/cjs.js!./index.less");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../_style-loader@0.23.1@style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../_css-loader@1.0.1@css-loader/index.js!../../_resolve-url-loader@3.1.0@resolve-url-loader/index.js!../../_less-loader@4.1.0@less-loader/dist/cjs.js!./index.less", function() {
		var newContent = require("!!../../_css-loader@1.0.1@css-loader/index.js!../../_resolve-url-loader@3.1.0@resolve-url-loader/index.js!../../_less-loader@4.1.0@less-loader/dist/cjs.js!./index.less");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}